module.exports = __webpack_public_path__ + "img/risk-higher.92075de9.png";